import {createAction} from '@reduxjs/toolkit';

export const setColorEnhanceMode = createAction('enhanceMode/setMode');

export const setEnhanceFilters = createAction('enhanceMode/setFilters');
